<template>
  <div class="content" style="z-index: 100">
    <!-- <div style="margin-top:44px;"> -->
      <div class="content-title">福建省外事服务中心</div>
      <div class="content-englishname">Fujian Foreign Affairs Service Center</div>
      <div class="content-search">
        <!-- <a-auto-complete v-model="searchKey" :options="options" style="width: 200px" placeholder="input here" @select="onSelect">
        <a-input-search placeholder="input here" size="large" @search="search"></a-input-search>
      </a-auto-complete> -->
        <a-input-search placeholder="搜索您想了解的业务/资讯/服务" size="large" @search="search" @change="searchChange" v-model="searchText">
          <a-button slot="enterButton" type="primary" class="search-button-oa" @click="search">
            <a-icon type="search" />搜索
          </a-button>
        </a-input-search>
        <!-- <div v-html="'2022年度福建省外事服务<em>中心</em>部门预算'"></div> -->
        <div :class="searchList.length == 0 ? 'search-div-none' : 'search-div'">
          <div class="li-box" v-for="item in searchList" :key="item.uid" @click="goDetail(item.contentTitle, item.contentId, item.contentType)">
            <div v-html="item.contentTitle"></div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { getList } from "@/api/search.js";
const mockVal = (str, repeat = 1) => {
  return {
    value: str.repeat(repeat),
  };
};
export default {
  name: "content",
  data () {
    return {
      searchKey: "",
      searchText: "",
      value: "",
      options: ["assaas", "asdasas", "saojdhyadsy"],
      MockVal: { value: "string" },
      searchList: [],
    };
  },
  methods: {
    searchChange (e) {
      console.log(e.target.value);
      if (e.target.value) {
        var params = {
          appCode: "APPAFBB8CD316AFF62",
          inputText: e.target.value,
          moduleCode: "",
          topResourceCode: "",
          pageNo: 1,
          pageSize: 10,
          tenantCode: "96F307B9D0EDF9F",
        };
        getList(params).then((res) => {
          this.searchList = this._.get(res, "data.list", []);
        });
      } else {
        this.searchList = [];
      }
    },
    goDetail (contenttitle, contentCode, contentType) {
      this.searchText = contenttitle;
      const mapType = {
        ANNOUNCE: "contentAnnounce",
        NEWS: "",
        HELP: "",
      };
      const type = this.$route.query.type || "";
      const linkname = this.$route.query.linkname || "";
      this.pushRouter(
        `/guide?contentCode=${contentCode}&type=${mapType[contentType]}&linkname=${linkname}`
      );
    },
    returnTitle (t) {
      return t.replace(/em/, `em style='color: #cbb486; padding: 0 3px;'`);
    },
    search (e) {
      this.searchKey = e;
      this.searchList = []
      if (!this.searchKey) return;
      this.pushRouter(`/home/search?searchKey=${this.searchKey}`);
    },
    onSearch (searchText) {
      options.value = !searchText
        ? []
        : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)];
    },
  },
};
</script>

<style scoped lang='less'>
[ant-click-animating],
[ant-click-animating-without-extra-node] {
  position: relative;
}
[ant-click-animating-without-extra-node]:after,
.ant-click-animating-node {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  border-radius: inherit;
  border: 0 solid #1890ff;
  opacity: 0.2;
  -webkit-animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1),
    waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1),
    waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  display: block;
  pointer-events: none;
}
@-webkit-keyframes waveEffect {
  100% {
    top: -6px;
    left: -6px;
    bottom: -6px;
    right: -6px;
    border-width: 6px;
  }
}
@keyframes waveEffect {
  100% {
    top: -6px;
    left: -6px;
    bottom: -6px;
    right: -6px;
    border-width: 6px;
  }
}
@-webkit-keyframes fadeEffect {
  100% {
    opacity: 0;
  }
}
@keyframes fadeEffect {
  100% {
    opacity: 0;
  }
}
/deep/.ant-input:focus {
  outline: none;
  border: none !important;
  box-shadow: none !important;
}
.search-div {
  // border-left: 1px solid #eeeeee;
  // border-right: 1px solid #eeeeee;
  // border-bottom: 1px solid #eeeeee;
  position: absolute;
  border: 1px solid #eeeeee;
  padding: 0 10px;
  border-radius: 10px;
  // margin-top: 5px;
  background: #ffffff;
  z-index: 1000;
  em {
    color: #cbb486;
    font-style: normal;
  }
}
/deep/ em {
  color: #cbb486;
  font-style: normal;
}
.search-div-none {
  display: none;
}

.li-box {
  display: flex;
  width: 100%;
  text-align: left;
  // border-bottom: 1px solid #eeeeee;
  cursor: pointer;
  & > div:nth-of-type(1) {
    /* flex: 1; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 40px;
  }
  // & > div:nth-of-type(1)::before {
  //   content: "";
  //   display: inline-block;
  //   width: 6px;
  //   height: 6px;
  //   border-radius: 50%;
  //   background: #cbb486;
  //   margin-right: 10px;
  //   transform: translateY(-2px);
  // }
  // & > div:nth-of-type(2) {
  //   flex: 100px;
  //   font-size: 14px;
  //   font-family: Microsoft YaHei;
  //   font-weight: 400;
  //   color: #bcbec0;
  //   text-align: right;
  //   line-height: 50px;
  // }
}
.content {
  position: relative;
  width: 100%;
  height: 460px;
  // height: 414px;
  // background: rgba(0, 0, 0, 0);
  &-title {
    width: 406px;
    height: 44px;
    font-size: 40px;
    letter-spacing: 5px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    color: #ffffff;
    line-height: 30px;
    position: absolute;
    top: 86px;
    width: 500px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
  }
  &-englishname {
    width: 435px;
    height: 20px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
    opacity: 0.68;
    position: absolute;
    top: 143px;
    width: 500px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
  }
  &-search {
    width: 700px;
    height: 60px;
    position: absolute;
    top: 195px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
  }
  /deep/ .ant-input-group .ant-input {
    height: 60px;
  }
  /deep/ .ant-input-group-addon {
    width: 126px;
    background: linear-gradient(45deg, #e7c78b, #d4a666, #cc9856);
    border-radius: 0px 6px 6px 0px;
  }
  /deep/ .ant-input-group-addon:hover {
    background: linear-gradient(45deg, #e7c78b, #d4a666, #bb8e35);
    background-size: 100% 150%;
  }
  /deep/ .ant-btn-primary {
    background: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
    box-shadow: none;
  }
  /deep/ .ant-input:hover {
    outline: none;
    border-color: rgb(217, 217, 217);
  }
  /deep/ .ant-input:focus {
    outline: none;
    border-color: rgb(217, 217, 217) !important;
  }
  .content-search /deep/ .ant-input {
    background-color: rgba(255, 255, 255, 0.3) !important;
    outline: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/content.vue